'use client'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import {
  type UseFieldGridFieldProps,
  useFieldGridField,
} from '../../hooks/use-field-grid-field.ts'
import { getTestProps, type TestIds } from '../../utils'

export type DataListItemProps = PropsWithChildren<
  UseFieldGridFieldProps & { className?: string } & TestIds
>

const DataListItem = ({
  children,
  className,
  dataTestId,
  dataTrackingId,
  ...fieldGridFieldProps
}: DataListItemProps) => {
  const { fieldGridFieldClassName } = useFieldGridField(fieldGridFieldProps)

  return (
    <div
      className={cn(
        'flex flex-col gap-2 overflow-hidden',
        fieldGridFieldClassName,
        className
      )}
      {...getTestProps({ dataTestId, dataTrackingId })}
    >
      {children}
    </div>
  )
}

export { DataListItem }
